import config from '../internetConfig';
import utils from '../../utils';
import axios from 'axios';
let suggestedTerms = [];

const load = new Promise((resolve) =>{

	if(!config.suggested.url) {
		return resolve(true);
	}
	axios.
	get(config.suggested.url).
	then((response) => {
		suggestedTerms = utils.toArray(response.data);
		suggestedTerms = buildHierarchy( suggestedTerms );
		resolve();
	})
	.catch((error) => {
		config.debug && console.error('Search: CIOs Error:', error);
		resolve();
	});
});

const buildHierarchy = ( data ) => {
	const hierarchy = [];
	const levels  = [hierarchy];

	data.forEach( item => {
		const level = item.level;

		if( !levels[level] ) {
			levels[level] = [];
		}

		// If it's a Top Level Item, Push it into our Hierarchy
		if( level === 0){
			hierarchy.push(item);
		} else {
			// Push Item into the previous Level's last Item's Children
			const parent = levels[level - 1][levels[level - 1].length - 1];
			if (!parent.children) {
			  parent.children = [];
			}
			parent.children.push(item);
		}
		    // Add item to the levels array at its level, replacing any existing item at this level
			levels[level] = [item];
	});
	return hierarchy;
}

const getTerms = ( term, array = suggestedTerms ) => {
	const searchTerm = String( term ).toLowerCase();
	if( searchTerm ) {
		for( let item of array ) {
			if( String(item.text).toLowerCase().includes( searchTerm ) ) {
				const result = {
					name: item.text,
					children: []
				}
				if( item.children && item.children.length > 0 ) {
					result.children = item.children.slice(0, 5).map(child => child.text);
				}
				return result;
			}
			if (item.children && item.children.length > 0) {
				const childResult = getTerms(searchTerm, item.children );
				if (childResult) {
					return childResult;
				}
			}
		}
		return null;
	} else {
		return [];
	}
}

export default { load, getTerms };
